import React, { Component } from 'react';
import * as BinLabelAction from '../actions/BinLabelAction';
import BinLabelStore from '../stores/BinLabelStore';
import * as $ from 'jquery';
import * as CookieService from '../CookieService';
import ReactPaginate from 'react-paginate';
import SDIConstants from '../SDIConstants';
import Select from 'react-select';
import { withTranslation, Trans } from 'react-i18next'
import { pdf } from '@react-pdf/renderer';
import { saveAs } from 'file-saver';
import PDFcomponent from './PDFConvert'
import Chip from '@material-ui/core/Chip';
import swal from 'sweetalert';
import * as MenuAction from '../actions/MenuAction';

import {
    Document,
    Page,
    Text,
    Image,
    View,
    StyleSheet,
} from '@react-pdf/renderer';
import { Dropdown } from 'react-multi-select-component';
import { style } from '@material-ui/system';
const styles = StyleSheet.create({
    page: {
        backgroundColor: 'white',
        display: 'block',
    },
    view: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        width: '100%',
    },
    QRImage: {
        width: '10%',
        height: '100%',
    },
    text: {
        color: '#0081C6',
        size: '2em',
    },
    root: {
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
        listStyle: 'none',


    },

});

let currentPagePath;
let isTruckUser = "";
let Glob_Crib_ID = {};
class BinLabelComponent extends Component {
    constructor(props) {
        super(props);
        const { valueStrings } = props;
        //const { PDFImageIds } = props;
        //const IdsArray = [];
        this.state = {
            ItemList: [],
            Crib_ID: {},
            Type: "",
            Area: {},
            Aisle: {},
            Row: {},
            Shelf: {},
            Bin: {},
            CribDD: [],
            AreaDD: [],
            SelectAll: true,
            AisleDD: [],
            RowDD: [],
            ShelfDD: [],
            BinDD: [],
            PageLoadData: [],
            GridLoadData: [],
            pageCount: "",
            pageNo: "1",
            CheckedGrid: [],
            ItemIdList: [],
            ItemId: "",
            SelectedId: [],
            CribNoOptionMsg: "Loading.......",
            ItemNoOptionMsg: "No options", //10/01/2025 - 5455 - In bin label printing panel  on entering invalid input not displayed with NO Option - Johnprinto D
            CribDisable: false,
            isFavorited: false, Page_ID: ""
        }
        isTruckUser = CookieService.getLocalStorageValues("Session_TRUCK_USER");
    }

    componentDidMount() {
        CookieService.updateLocalStorageValues("Session_PageName", window.location.pathname);
        currentPagePath = this.props.location.pathname;
        currentPagePath = currentPagePath.indexOf("?") >= 0 ? currentPagePath.split("?")[0] : currentPagePath;
        let getFavPageBO = {
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            pageURL: currentPagePath.toLowerCase(),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
        };
        BinLabelAction.getCurrentFavPage(getFavPageBO);
        // $(`#${SDIConstants.SDILoader}`).addClass('hide');
        //PC_CPW_280_02, Vishwa S
        if (CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT") == null || CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT") == undefined ||
            CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT") == "" || CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT") == " " ||
            CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT").toUpperCase() != "0W0T") {
            let cribID = CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT");
            if (CookieService.getLocalStorageValues("HideMobility") && CookieService.getLocalStorageValues("HideMobility").toUpperCase() == "TRUE") {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "This page is exclusively for Truckstock. Please contact your admin/manager to set up the truck crib"
                });
                this.props.history.push({
                    pathname: `/homepage`
                });
            }
            else {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "This page is exclusively for Truckstock. Please select truck crib from user profile to proceed"
                });
                this.props.history.push({
                    pathname: `/profile`,
                    state: { origin: 'Inventory' }
                });
            }
            return;
        }
        this.BinLocPageLoad();
        let resultArray = [];
        if (this.state.GridLoadData.length > 0) {
            this.state.GridLoadData.map(valueString => {
                resultArray.push(document.getElementById(valueString.BARITEMID).toDataURL())
            })
        }
        this.setState({ resultArray: resultArray })

        BinLabelStore.on('PageLoad', this.BinLocPageLoadResponse);
        BinLabelStore.on('CribRecords', this.CribRecordsresponse);
        BinLabelStore.on('GridLoad', this.BinLocGridLoadResponse);
        BinLabelStore.on('favpage', this.loadFavPageResponse);
        BinLabelStore.on('updateFavPage', this.updateFavPageResponse);
        BinLabelStore.on('LocationResponse', this.selectAreaResponse);


    }

    componentWillUnmount() {
        BinLabelStore.removeListener('PageLoad', this.BinLocPageLoadResponse);
        BinLabelStore.removeListener('CribRecords', this.CribRecordsresponse);
        BinLabelStore.removeListener('GridLoad', this.BinLocGridLoadResponse);
        BinLabelStore.removeListener('favpage', this.loadFavPageResponse);
        BinLabelStore.removeListener('updateFavPage', this.updateFavPageResponse);
        BinLabelStore.removeListener('LocationResponse', this.selectAreaResponse);

    }
    BinLocPageLoad = () => {

        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        //Bentonville is not showing in Bin label printing - Deepthi 
        let BinLabelPageLoadBO = {
            Session_User_Crib_ID: CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT")
        }
        BinLabelAction.BinLocPageLoad(BinLabelPageLoadBO);
        // $(`#${SDIConstants.SDILoader}`).addClass('hide');
    }


    BinLocPageLoadResponse = () => {
        //debugger
        let PageLoadResponse = JSON.parse(BinLabelStore.PageLoadData);
        //CPW-247 - Bin Label Printing page does not load in Production, it just spins. - Deepthi N H
        let BUArray = PageLoadResponse.BuData
        let ItemIDArray = PageLoadResponse.ItemIDData
        let AreaArray = [];
        let Areadd = [];
        let CribID = [];
        let ItemID = [];
        let locSelectedCrib = {};
        let locCribDisable = false
        if (BUArray != undefined && BUArray != null) {
            if (BUArray.length > 0) {
                BUArray.forEach((val, ind) => {
                    let locBu = {
                        value: val.BUSINESS_UNIT,
                        label: val.DESCR
                    };
                    CribID.push(locBu);
                    if (CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT") == val.BUSINESS_UNIT.slice(1)) {
                        //if (CookieService.getLocalStorageValues("Session_TRUCK_USER") == "True") {
                        locSelectedCrib = locBu
                        locCribDisable = true
                        //}
                    }
                })
            }
            else {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Oops! Something went wrong"
                });
            }
        }
        else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Oops! Something went wrong"
            });
        }
        if (ItemIDArray != undefined && ItemIDArray != null) {
            if (ItemIDArray.length > 0) {
                ItemIDArray.forEach((val, ind) => {
                    let locItem = {
                        value: val.INV_ITEM_ID,
                        label: val.INV_ITEM_ID
                    }
                    ItemID.push(locItem);
                })
            }
            else {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Oops! Something went wrong"
                });
            }
        }
        else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Oops! Something went wrong"
            });
        }

        let pp = CribID.filter((ele, ind) => ind === CribID.findIndex(elem => elem.value === ele.value && elem.label === ele.label))
        let pp1 = ItemID.filter((ele, ind) => ind === ItemID.findIndex(elem => elem.value === ele.value && elem.label === ele.label))
        //BLP_PC_06 WW-726 'Bin' filter doesn't work correctly on the Bin Label Printing page - Deepthi N H
        let CribMsg = CribID.length == 0 ? "No options" : this.state.CribNoOptionMsg;
        let ItemMsg = ItemID.length == 0 ? "No options" : this.state.ItemNoOptionMsg;
        if (locCribDisable) {
            AreaArray = PageLoadResponse.AreaData
            if (AreaArray != undefined && AreaArray != null && AreaArray.length != 0) {
                AreaArray.map((area, index) => {
                    if (Areadd.indexOf(area.STORAGE_AREA) == -1) {
                        let obj = {
                            value: area.STORAGE_AREA,
                            label: area.STORAGE_AREA
                        }
                        Areadd.push(obj)
                    }
                })
            }
            else {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Oops! Something went wrong"
                });
            }
        }

        let locAreadd = Areadd.filter((ele, ind) => ind === Areadd.findIndex(elem => elem.value === ele.value && elem.label === ele.label))
        this.setState({ CribDD: pp, AreaDD: locAreadd, ItemIdList: pp1, Crib_ID: locSelectedCrib, CribDisable: locCribDisable, CribNoOptionMsg: CribMsg, ItemNoOptionMsg: ItemMsg, PageLoadData: ItemIDArray });
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
    }

    BinLocGridLoad = (type) => {
      
        let arr = []
        let valid = true
        //PC_CPW_280_04, Vishwa S
        //if ((this.state.Crib_ID == "" || Object.keys(this.state.Crib_ID).length == 0) && this.state.SelectedId.length == 0) {
        //    swal({
        //        allowOutsideClick: false,
        //        closeOnClickOutside: false,
        //        text: "Please select either crib id or item Id to get data"
        //    });
        //    valid = false
        //    return;
        //}
        if (this.state.SelectedId.length != 0)
            this.state.SelectedId.map((item, index) => {
                arr.push(item.label)
            })
        if (this.state.SelectedId == undefined || this.state.SelectedId == null || this.state.SelectedId.length == 0) {
            if (this.state.Area.value == undefined || this.state.Area == null) {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Please select either area or item id to get data"
                });
                valid = false
            }
        }
        if (valid) {
            let BinBO = {
                ItemID: arr,
                strType: type,
                User_Crib_ID: CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT"),
                Crib_ID: CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT"), //PC_CPW_280_04, Vishwa S
                //Crib_ID: this.state.Crib_ID.value != undefined ? this.state.Crib_ID.value.slice(1) : "", //WW-342 Bin Label Printing Panel Not Pulling Up Items Correctly - Deepthi
                Area: this.state.Area.value != undefined ? this.state.Area.value : "", //WW-342 Bin Label Printing Panel Not Pulling Up Items Correctly - Deepthi
                Aisle: this.state.Aisle.value != undefined ? this.state.Aisle.value : "", //WW-342 Bin Label Printing Panel Not Pulling Up Items Correctly - Deepthi
                Row: this.state.Row.value != undefined ? this.state.Row.value : "", //WW-342 Bin Label Printing Panel Not Pulling Up Items Correctly - Deepthi
                Shelf: this.state.Shelf.value != undefined ? this.state.Shelf.value : "", //WW-342 Bin Label Printing Panel Not Pulling Up Items Correctly - Deepthi
                Bin: this.state.Bin.value != undefined ? this.state.Bin.value : "" //WW-342 Bin Label Printing Panel Not Pulling Up Items Correctly - Deepthi
            }
            //BLP_PC_02,  WW-726 'Bin' filter doesn't work correctly on the Bin Label Printing page - Deepthi N H
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            BinLabelAction.BinLocGridLoad(BinBO);
        }
    }

    BinLocGridLoadResponse = () => {
        
        let PageLoadResp = JSON.parse(BinLabelStore.GridLoadData);
        let GridLoadData = PageLoadResp.Table;
        GridLoadData.forEach((value, index) => {
            GridLoadData[index].isChecked = false;
        })
        if (GridLoadData == undefined || GridLoadData.length == 0 || GridLoadData == null) {
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "No data found"
            });
            // alert("No data found");
            return;
        }
        //BLP_PC_03,  WW-726 'Bin' filter doesn't work correctly on the Bin Label Printing page - Deepthi N H
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        console.log("GridLoadData", GridLoadData);
        this.setState({ GridLoadData: GridLoadData, SelectAll: true, pageCount: parseFloat(GridLoadData.length) / 10, CheckedGrid: [], pageNo: "1" });//WW-334_PC_02 Bin Label Printing Download PDF Not Opening (1/12/2022) -Aparna

    }
    selectCribChange = (e) => {
     
        //CPW-247 - Bin Label Printing page does not load in Production, it just spins. - Deepthi N H
        Glob_Crib_ID = e;
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        //Bentonville is not showing in Bin label printing - Deepthi 
        let BinLabelPageLoadBO = {
            Session_User_Crib_ID: e.value.slice(1)
        }
        BinLabelAction.GetCribRecords(BinLabelPageLoadBO);
    }
    //CPW-247 - Bin Label Printing page does not load in Production, it just spins. - Deepthi N H
    CribRecordsresponse = () => {
        //debugger

        let Areadd = [];
        let LocDetails = JSON.parse(BinLabelStore.CribRecords);
        if (LocDetails != undefined && LocDetails != null) {
            if (LocDetails.length > 0) {
                LocDetails.forEach((item, index) => {
                    if (Areadd.indexOf(item.STORAGE_AREA) == -1) {
                        let obj = {
                            value: item.STORAGE_AREA,
                            label: item.STORAGE_AREA
                        }
                        Areadd.push(obj);
                    }
                })
            }
        }
        $(`#${SDIConstants.SDILoader}`).addClass('hide');

        let pp = Areadd.filter((ele, ind) => ind === Areadd.findIndex(elem => elem.value === ele.value && elem.label === ele.label))
        this.setState({ AreaDD: pp, SelectedId: [], Crib_ID: Glob_Crib_ID, PageLoadData: LocDetails, ItemId: {}, Area: {}, Aisle: {}, AisleDD: [], Shelf: {}, ShelfDD: [], Bin: {}, BinDD: [], Row: {}, RowDD: [], GridLoadData: [] })
    }
    selectAreaChange = (e) => {
       
        let area = e;
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        let BinLabelAreaBO = {
            Crib_ID: this.state.Crib_ID.value.slice(1),
            Area: e.value
        }
        BinLabelAction.GetLocationDetails(BinLabelAreaBO);
        this.setState({ Area: area })
    }

    selectAreaResponse = () => {
        let LocDetails = JSON.parse(BinLabelStore.LocationData);
        let Aisledd = [];
        if (LocDetails != undefined && LocDetails != null && LocDetails.length > 0) {
            LocDetails.forEach((item, index) => {
                if (Aisledd.indexOf(item.STOR_LEVEL_1) == -1) {
                    let obj = {
                        value: item.STOR_LEVEL_1,
                        label: item.STOR_LEVEL_1
                    }
                    Aisledd.push(obj);
                }
            })
        }
        $(`#${SDIConstants.SDILoader}`).addClass('hide');

        let pp = Aisledd.filter((ele, ind) => ind === Aisledd.findIndex(elem => elem.value === ele.value && elem.label === ele.label))
        this.setState({ AisleDD: pp, SelectedId: [], Aisle: {}, PageLoadData: LocDetails, ItemId: {}, Shelf: {}, ShelfDD: [], Bin: {}, BinDD: [], Row: {}, RowDD: [], GridLoadData: [] })

    }



    selectAisleChange = (e) => {
        
        let aisle = e;
        let Rowdd = [];
        this.state.PageLoadData.map((item, index) => {
            if (item.STOR_LEVEL_1 == e.value && Rowdd.indexOf(item.STOR_LEVEL_2) == -1
            ) {
                let obj = {
                    value: item.STOR_LEVEL_2,
                    label: item.STOR_LEVEL_2
                }
                Rowdd.push(obj);
            }
        })
        let pp = Rowdd.filter((ele, ind) => ind === Rowdd.findIndex(elem => elem.value === ele.value && elem.label === ele.label))
        this.setState({ Aisle: aisle, RowDD: pp, Shelf: {}, ShelfDD: [], Bin: {}, BinDD: [], Row: {}, GridLoadData: [] })
    }

    selectRowChange = (e) => {
      
        let row = e;
        let Shelfdd = [];
        this.state.PageLoadData.map((item, index) => {
            if (item.STOR_LEVEL_1 == this.state.Aisle.value && item.STOR_LEVEL_2 == e.value && Shelfdd.indexOf(item.STOR_LEVEL_3) == -1
            ) {
                let obj = {
                    value: item.STOR_LEVEL_3,
                    label: item.STOR_LEVEL_3
                }
                Shelfdd.push(obj);
            }
        })
        let pp = Shelfdd.filter((ele, ind) => ind === Shelfdd.findIndex(elem => elem.value === ele.value && elem.label === ele.label))
        this.setState({ ShelfDD: pp, Row: row, Shelf: {}, Bin: {}, BinDD: [], GridLoadData: [] })
    }

    selectShelfChange = (e) => {
        
        let shelf = e;
        let Bindd = [];
        this.state.PageLoadData.map((item, index) => {
            if (item.STOR_LEVEL_1 == this.state.Aisle.value && item.STOR_LEVEL_3 == e.value && item.STOR_LEVEL_2 == this.state.Row.value && Bindd.indexOf(item.STOR_LEVEL_4) == -1
            ) {
                //BLP_PC_01,  WW-726 'Bin' filter doesn't work correctly on the Bin Label Printing page - Deepthi N H
                let obj = {
                    value: item.STOR_LEVEL_4,
                    label: item.STOR_LEVEL_4
                }
                Bindd.push(obj);
            }
        })
        let pp = Bindd.filter((ele, ind) => ind === Bindd.findIndex(elem => elem.value === ele.value && elem.label === ele.label))
        this.setState({ BinDD: pp, Shelf: shelf, Bin: {}, GridLoadData: [] })
    }
    selectBinChange = (e) => {
        
        let bin = e;
        this.setState({ Bin: bin, GridLoadData: [] })
    }


    selectItemChange = (e) => {

        let Item = e;
        let ItemList = this.state.SelectedId;
        ItemList.push(e);
        let pp = ItemList.filter((ele, ind) => ind === ItemList.findIndex(elem => elem.value === ele.value && elem.label === ele.label))
        let locCrib_ID = this.state.Crib_ID
        let locAreaDD = this.state.AreaDD
        //CPW-280 -Vishwa S
        //if (CookieService.getLocalStorageValues("Session_TRUCK_USER") == "False") {
        //    locCrib_ID = {}
        //    locAreaDD = {}
        //}
        this.setState({ ItemId: Item, SelectedId: pp, Crib_ID: locCrib_ID, Area: {}, /*AreaDD: [],*/ Aisle: {}, AisleDD: [], Shelf: {}, ShelfDD: [], Bin: {}, BinDD: [], Row: {}, RowDD: [], GridLoadData: [] })

    }

    handleDelete = (chipToDelete) => () => {
        
        let chipdate = this.state.SelectedId.filter((chip, index) => index != chipToDelete);
        let Item_Id = this.state.ItemId;
        if (this.state.SelectedId[chipToDelete].value == this.state.ItemId.value) {
            Item_Id = "";
        }
        //CPW-159 QR scan is returning incorrect results - change back to be the item - Deepthi N H
        this.setState({ SelectedId: chipdate, ItemId: Item_Id, GridLoadData: [] });
    };

    selectedItem = () => {

        return (
            <ul style={styles.root} className="mt-4 px-0 pt-2">
                {this.state.SelectedId.map((data, index) => {
                    return (
                        <Chip
                            label={data.label}
                            onDelete={this.handleDelete(index)}
                            className={styles.chip}
                            style={{ "margin-right": "12px" }}
                        />
                    );
                })}
            </ul>
        );
    }

    handleChkbox = (event, i, obj) => {

        $(`qtyonhand_${i}`).prop('checked', !event.target.checked);
        let localChck = this.state.CheckedGrid;
        let isChecked = false;
        if (event.target.checked == true) {
            this.state.GridLoadData.map((item, index) => {
                if (index == i) {
                    localChck.push(item);
                }

            })
            isChecked = true;
        } else if (event.target.checked == false) {

            localChck = this.state.CheckedGrid.filter(item => item != obj);
            isChecked = false;

        }
        if (this.state.GridLoadData.length === localChck.length) {
            this.setState({ SelectAll: false });
        }
        else {
            this.setState({ SelectAll: true });
        }
        let { GridLoadData } = this.state;
        GridLoadData[i].isChecked = isChecked;
        this.setState(GridLoadData);
        this.setState({ CheckedGrid: localChck });
    }
    //*CPW-118 select all option * -Pavithra R(10 / 20 / 2023)
    btnselectLocItemsOnClick = (type) => {

        let localChck = []

        switch (type) {
            case "SelectAll": {
                let GridData = this.state.GridLoadData
                GridData.forEach((item, i) => {

                    GridData[i].isChecked = true

                    localChck.push(item)

                })

                this.setState({ CheckedGrid: localChck, SelectAll: false, GridLoadData: GridData }); /*4195, cannot sort when selecting all location, Divis Kumar R K*/
                break;
            }

            case "UnSelect": {
                let GridData = this.state.GridLoadData
                GridData.forEach((x, i) => {

                    GridData[i].isChecked = false

                })
                localChck = []

                this.setState({ CheckedGrid: localChck, GridLoadData: GridData, SelectAll: true, });
                break;
            }

        }

    }


    BindGridData = () => {

        if (this.state.GridLoadData.length > 0) {
            return this.state.GridLoadData.map((value, index) => {
                
                let check = value.isChecked;
                //let tl_cost = Math.round(parseFloat(value.TL_COST), 2);
                //let ext_cost = Math.round(parseFloat(value.EXT_COST), 2)
                if (index < parseInt(this.state.pageNo) * 10 && index >= parseInt(this.state.pageNo - 1) * 10) {
                   
                    return (<React.Fragment key={index}>
                        <tr>
                            <td>{value.CRIB}</td>
                            <td> {value.BINLOCATION}</td>
                            <td>{value.UNIT_OF_MEASURE}</td>
                            <td> {value.INV_ITEM_ID}</td>
                            <td>{value.DESCR}</td>
                            <td>{value.MFG_ID}</td>
                            <td>{value.QTY}</td>
                            <td className={isTruckUser == "True" ? "hideColumn" : ""}> <div className="custom-control custom-checkbox my-2 item-custom-control d-inline-block" style={{ marginLeft: '2%' }}>
                                <input disabled={true} type="checkbox" className="custom-control-input" id="qtyonhandid" name="example4" checked={value.DEFAULT_LOC == "True" ? true : false} />
                                <label className="custom-control-label priority-checkbox profile-update-checkbox" htmlFor="qtyonhandid"></label>

                            </div>
                            </td>
                            <td>
                                <div className="custom-control custom-checkbox my-2 item-custom-control d-inline-block" style={{ marginLeft: '2%' }}>
                                    <input type="checkbox" className="custom-control-input" id={`qtyonhand_${index}`} name="example4" checked={value.isChecked} onChange={(e) => this.handleChkbox(e, index, value)} />
                                    <label className="custom-control-label priority-checkbox profile-update-checkbox" htmlFor={`qtyonhand_${index}`}></label>
                                </div>
                            </td>
                        </tr>

                    </React.Fragment>

                    );
                }
            })
        }
        // * CPW - 118 select all option * -Pavithra R(10 / 20 / 2023)
        else {
            return (

                <section className="site-undercontruction container text-center center-panel pt-4">
                    <div className="img-section">
                        <img src="images/nosearch.jpg" alt="imagefile" />
                    </div>
                    <p className="search-result-content pt-4"><Trans>No Records found</Trans>
                    </p>
                </section>);


        }
    }
    handleFavorite = (event) => {
        this.setState({ isFavorited: event.target.checked });
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        if (event.target.checked == true) {
            let insertFavPageBO = {
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                pageURL: currentPagePath.toLowerCase(),
                pageTitle: "Bin Label Printing",
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
            }
            BinLabelAction.insertFavPage(insertFavPageBO)
        } else {
            let deleteFavPageBO = {
                Page_ID: this.state.Page_ID
            }
            BinLabelAction.deleteFavPage(deleteFavPageBO)
        }
    };
    loadFavPageResponse = () => {

        let favPageResponse = JSON.parse(BinLabelStore.currentFavPageResponse);
        if (favPageResponse.length > 0) {
            favPageResponse = favPageResponse[0];
            this.setState({ isFavorited: true, Page_ID: favPageResponse.PAGE_ID });
        };
    };
    refreshMenu = () => {
        let masterBO = {
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            Session_AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
            Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
            isRequestorApproval: CookieService.getLocalStorageValues("hasReqApprovalCheck"),
            isOrderApproval: CookieService.getLocalStorageValues("hasOrderApprovalCheck"),
            isFavItem: CookieService.getLocalStorageValues("hasFavItemCheck"),
            isFavOrder: CookieService.getLocalStorageValues("hasFavOrderCheck"),
            isFirstTime: false,
            IsWeb: true,//isFirstTimeLoaded
            HOME_STORE: CookieService.getLocalStorageValues("HOME_STORE"), //CPW-167_PC_
        };
        console.log("masterBO", masterBO);
        MenuAction.getMasterData(masterBO);
    };
    updateFavPageResponse = () => {
        if (BinLabelStore.updateFavPageResponse.updateType == 1) {
            let response = JSON.parse(BinLabelStore.updateFavPageResponse.responseStr)[0];
            if (response.is_Success == "True") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: true, Page_ID: response.Page_ID });
                MenuAction.toastMessage(1);
            }
        } else {
            let response = JSON.parse(BinLabelStore.updateFavPageResponse.responseStr)[0];
            if (response.success == "true") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: false });
                MenuAction.toastMessage(2);
            }
        }
        this.refreshMenu();
    };
    handlePageClick = (e) => {
        let pageNo = e.selected + 1;
        this.setState({ pageNo: pageNo });
    }


    //QRCodeGenerate = () => {
    //    
    //    let arr = [];
    //    if (this.state.GridLoadData.length > 0) {
    //        return (
    //            <div>
    //                <PDFDownloadLink
    //                    document={this.PDF()}
    //                    fileName={"testing.pdf"}
    //                >
    //                    <Button
    //                        type="primary"
    //                        style={{ 'margin-top': '1rem', 'margin-bottom': '2rem' }}
    //                    >
    //                        Testing PDF
    //        </Button>
    //                </PDFDownloadLink>
    //            </div>
    //        )
    //    }
    //}

    //_exportPdf = () => {
    //    
    //    const pdf = new jsPDF();
    //    let doc = document.implementation.createHTMLDocument("New Document");
    //    let p = doc.createElement("body");
    //    p.style.width = "8.5in";
    //    p.style.margin = "0in .1875in";

    //        html2canvas(document.querySelector("#testing")).then(canvas => {
    //            p.appendChild(canvas);  
    //            const imgData = canvas.toDataURL('image/png');
    //            pdf.addImage(imgData, 'PNG', 0, 0);
    //            pdf.save("download.pdf");
    //    })



    //    }




    render() {
        return (
            //<div className="container-fluid content-section">
            <div className="container-fluid content-margin content-section">
                <div className="row">
                    <div className="col-md-12 page-heading mb-3">
                        <h5 className="page-title"><Trans>Bin Label Printing</Trans></h5>
                        <div className="fav-item-maintenance-icon mt-1">
                            <input type="checkbox" id="checkbox-Notify" className="checknow" data-toggle="modal" data-target="#Note-confirmation" name="isFavorited" checked={this.state.isFavorited} onChange={this.handleFavorite} />
                            <label htmlFor="checkbox-Notify">
                                <svg className="heart-svg" viewBox="467 392 58 57" xmlns="http://www.w3.org/2000/svg">
                                    <g className="Group" fill="none" fillRule="evenodd" transform="translate(467 392)">
                                        <path d="M29.144 20.773c-.063-.13-4.227-8.67-11.44-2.59C7.63 28.795 28.94 43.256 29.143 43.394c.204-.138 21.513-14.6 11.44-25.213-7.214-6.08-11.377 2.46-11.44 2.59z" className="heart" fill="#fff" />
                                        <circle className="main-circ" fill="#E2264D" opacity={0} cx="29.5" cy="29.5" r="1.5" />
                                        <g className="grp7" opacity={0} transform="translate(7 6)">
                                            <circle className="oval1" fill="#9CD8C3" cx={2} cy={6} r={2} />
                                            <circle className="oval2" fill="#8CE8C3" cx={5} cy={2} r={2} />
                                        </g>
                                        <g className="grp6" opacity={0} transform="translate(0 28)">
                                            <circle className="oval1" fill="#CC8EF5" cx={2} cy={7} r={2} />
                                            <circle className="oval2" fill="#91D2FA" cx={3} cy={2} r={2} />
                                        </g>
                                        <g className="grp3" opacity={0} transform="translate(52 28)">
                                            <circle className="oval2" fill="#9CD8C3" cx={2} cy={7} r={2} />
                                            <circle className="oval1" fill="#8CE8C3" cx={4} cy={2} r={2} />
                                        </g>
                                        <g className="grp2" opacity={0} transform="translate(44 6)">
                                            <circle className="oval2" fill="#CC8EF5" cx={5} cy={6} r={2} />
                                            <circle className="oval1" fill="#CC8EF5" cx={2} cy={2} r={2} />
                                        </g>
                                        <g className="grp5" opacity={0} transform="translate(14 50)">
                                            <circle className="oval1" fill="#91D2FA" cx={6} cy={5} r={2} />
                                            <circle className="oval2" fill="#91D2FA" cx={2} cy={2} r={2} />
                                        </g>
                                        <g className="grp4" opacity={0} transform="translate(35 50)">
                                            <circle className="oval1" fill="#F48EA7" cx={6} cy={5} r={2} />
                                            <circle className="oval2" fill="#F48EA7" cx={2} cy={2} r={2} />
                                        </g>
                                        <g className="grp1" opacity={0} transform="translate(24)">
                                            <circle className="oval1" fill="#9FC7FA" cx="2.5" cy={3} r={2} />
                                            <circle className="oval2" fill="#9FC7FA" cx="7.5" cy={2} r={2} />
                                        </g>
                                    </g>
                                </svg>
                            </label>
                        </div>
                    </div>
                    <div className="col-md-12 confirm-label mb-3" style={{ fontSize: 'medium' }}><span><Trans>Crib </Trans><Trans>ID</Trans> - <Trans>Walmart </Trans><Trans>Truckstock</Trans></span></div>{/*PC_CPW_280_03, Vishwa S*/}
                    <div className="col-md-12">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="row">
                                    {/*<div className="col-md-6 col-lg-4 mb-3">
                                    <label className="confirm-label  mandatory-after" style={{ "fontSize": "15px" }} ><Trans>Crib</Trans><span> </span><Trans>ID</Trans></label><label><span>:</span></label>
                                    <span style={{ "fontSize": "14px" }}><Select
                                        id="selectReportID0"
                                        placeholder="Select Crib ID"
                                        name="SelectReport"
                                        onChange={(e) => this.selectCribChange(e)}
                                        value={this.state.Crib_ID}
                                        options={this.state.CribDD}
                                        noOptionsMessage={() => this.state.CribNoOptionMsg}
                                        isDisabled={this.state.CribDisable}
                                    /></span>
                                </div>*/}
                                    <div className="col-md-6 col-lg-4 mb-3">
                                        <label className="confirm-label mandatory-after" style={{ "fontSize": "15px" }}><Trans>Area</Trans></label><label><span>:</span></label>
                                        <span style={{ "fontSize": "14px" }}><Select
                                            id="selectReportID1"
                                            placeholder="Select Area"
                                            name="SelectReport"
                                            onChange={(e) => this.selectAreaChange(e)}
                                            value={this.state.Area}
                                            options={this.state.AreaDD}
                                        /></span>
                                    </div>
                                    <div className="col-md-6 col-lg-4 mb-3">
                                        <label className="confirm-label" style={{ "fontSize": "15px" }} ><Trans>Aisle</Trans><span>:</span></label>
                                        <span style={{ "fontSize": "14px" }}><Select
                                            id="selectReportID2"
                                            placeholder="Select Aisle"
                                            name="SelectReport"
                                            onChange={(e) => this.selectAisleChange(e)}
                                            value={this.state.Aisle}
                                            options={this.state.AisleDD}
                                        /></span>
                                    </div>
                                    <div className="col-md-6 col-lg-4 mb-3">
                                        <label className="confirm-label" style={{ "fontSize": "15px" }}><Trans>Row</Trans><span>:</span></label>
                                        <span style={{ "fontSize": "14px" }}><Select
                                            id="selectReportID3"
                                            placeholder="Select Row"
                                            name="SelectReport"
                                            onChange={(e) => this.selectRowChange(e)}
                                            value={this.state.Row}
                                            options={this.state.RowDD}
                                        /></span>
                                    </div>
                                    <div className="col-md-6 col-lg-4 mb-3">
                                        <label className="confirm-label " style={{ "fontSize": "15px" }} ><Trans>Shelf</Trans><span>:</span></label>
                                        <span style={{ "fontSize": "14px" }}><Select
                                            id="selectReportID5"
                                            placeholder="Select Shelf"
                                            name="SelectReport"
                                            onChange={(e) => this.selectShelfChange(e)}
                                            value={this.state.Shelf}
                                            options={this.state.ShelfDD}
                                        /></span>
                                    </div>
                                    <div className="col-md-6 col-lg-4 mb-3">
                                        <label className="confirm-label" style={{ "fontSize": "15px" }} ><Trans>Bin</Trans><span>:</span></label>
                                        <span style={{ "fontSize": "14px" }}><Select
                                            id="selectReportID5"
                                            placeholder="Select Bin"
                                            name="SelectReport"
                                            onChange={(e) => this.selectBinChange(e)}
                                            value={this.state.Bin}
                                            options={this.state.BinDD}
                                        /></span>
                                    </div>

                                </div>

                                {/*<div className="col-md-12 mt-1 mb-1" id="OR" ><span>(</span><Trans>OR</Trans><span>)</span></div>*/}

                            </div>
                            <div className="d-md-none d-lg-none col-sm-12 text-center">
                                <label className="confirm-label" style={{ "fontSize": "15px" }} ><Trans>Or</Trans></label>
                            </div>
                            <div className="col-md-6 verticalline">
                                <div className="row">
                                    <div className="col-md-12">
                                        <label className="confirm-label" style={{ "fontSize": "15px" }} ><Trans>Item ID</Trans><span>:</span></label>
                                        <div className="col-md-12 col-sm-12 col-12 col-lg-6 px-0" style={{ "fontSize": "14px" }}><Select
                                            id="selectReportID6"
                                            placeholder="Select Item"
                                            name="SelectReport"
                                            onChange={(e) => this.selectItemChange(e)}
                                            value={this.state.ItemId}
                                            defaultValue={this.state.ItemIdList[0]}
                                            options={this.state.ItemIdList}
                                            noOptionsMessage={() => this.state.ItemNoOptionMsg}
                                        /></div>
                                    </div>
                                    <div className="col-md-12">
                                        {this.state.SelectedId.length > 0 ?
                                            this.selectedItem() : null}
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-12 col-sm-auto col-auto my-3 text-right">
                                {/**WW-334_PC_01 Bin Label Printing Download PDF Not Opening (1/12/ 2022) -Aparna*/}
                                {this.state.CheckedGrid.length > 0 && this.state.GridLoadData.length > 0 ? <button className="btn btn-primary custom-btn-primary primary-btn px-3 mr-2"
                                    onClick={async () => {

                                        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                                        const doc = <PDFcomponent PDFImageIds={this.state.CheckedGrid} key="key1" />;
                                        const asPdf = pdf([]);
                                        asPdf.updateContainer(doc);
                                        const blob = await asPdf.toBlob();
                                        saveAs(blob, 'BinLabelPrint.pdf');
                                        $(`#${SDIConstants.SDILoader}`).addClass('hide');
                                    }}
                                ><Trans>Download</Trans> PDF</button> : null}

                                {this.state.GridLoadData.length > 0 ?


                                    <button className="btn btn-primary custom-btn-primary primary-btn px-3 mr-2" onClick={() => this.btnselectLocItemsOnClick(this.state.SelectAll ? "SelectAll" : "UnSelect")}><trans> {this.state.SelectAll ? "Select All" : "Unselect All"} </trans> </button> : null}



                                <button className="btn btn-primary custom-btn-primary primary-btn px-3" onClick={() => this.BinLocGridLoad(this.state.SelectedId.length > 0 ? "Item" : "Bin")}><Trans>Get Data</Trans></button>

                            </div>

                        </div>
                    </div>
                    {/*<div className="horline">
                    </div>*/}


                    <div className="col-md-12">

                        <div className="table-responsive">
                            {this.state.GridLoadData.length > 0 ?
                                <table className="table ZEUS_Grid FOM-grid chk-ordertbl">
                                    <thead>
                                        <tr>
                                            <th className="d-md-table-cell position-sort-icon"><Trans>Crib</Trans><span> </span><Trans>ID</Trans></th>
                                            <th className="d-md-table-cell position-sort-icon"><Trans>Bin</Trans><span> </span><Trans>Location</Trans></th>
                                            <th className="d-md-table-cell position-sort-icon">UOM</th>
                                            <th className="d-md-table-cell position-sort-icon"><Trans>Inventory</Trans><span> </span><Trans>Id</Trans></th>
                                            <th className="d-md-table-cell position-sort-icon"><Trans>Description</Trans></th>
                                            <th className="d-md-table-cell position-sort-icon"><Trans>Manufacturer</Trans></th>
                                            <th className="d-md-table-cell position-sort-icon"><Trans>Quantity</Trans></th>
                                            <th className={isTruckUser == "True" ? "d-md-table-cell position-sort-icon hideColumn" : "d-md-table-cell position-sort-icon"}><Trans>Default</Trans><span> Loc</span></th>
                                            <th className="d-md-table-cell position-sort-icon"><Trans>Print</Trans></th>
                                        </tr>
                                    </thead>
                                    <>
                                        <tbody>
                                            {this.state.PageLoadData.length > 0 ? this.BindGridData() : null}
                                        </tbody>

                                    </>

                                </table>
                                : null}
                        </div>
                        {this.state.GridLoadData.length > 0 ?
                            <div className="col-md-12 mb-3 p-0">
                                <span className="total-records mb-2">
                                    <Trans>Number of Records</Trans><span> :</span><span className="ml-2">{this.state.GridLoadData.length}</span>
                                </span>
                                {this.state.GridLoadData.length > 0 ? <ReactPaginate
                                    previousLabel={<span className="right-pagination-arrow" />}
                                    nextLabel={<span className="left-pagination-arrow" />}
                                    previousClassName={'page-item'}
                                    nextClassName={'page-item'}
                                    previousLinkClassName={'page-link'}
                                    nextLinkClassName={'page-link'}
                                    disabledClassName={'disabled'}
                                    breakLabel={'...'}
                                    breakClassName={'page-item'}
                                    breakLinkClassName={'page-link'}
                                    pageCount={this.state.pageCount}
                                    marginPagesDisplayed={1}
                                    pageRangeDisplayed={2}
                                    onPageChange={this.handlePageClick}
                                    containerClassName={'custom-pagination pagination float-right'}
                                    pageClassName={'page-item'}
                                    pageLinkClassName={'page-link'}
                                    activeClassName={'active'}
                                    hrefBuilder={() => '#'}
                                    forcePage={this.state.pageNo - 1}
                                /> : null}

                            </div> : null}
                    </div>
                </div>
            </div>

        );
    };
}
export default withTranslation()(BinLabelComponent); 